import { render, staticRenderFns } from "./ProfessionItem.vue?vue&type=template&id=4294660c&scoped=true&"
import script from "./ProfessionItem.vue?vue&type=script&lang=js&"
export * from "./ProfessionItem.vue?vue&type=script&lang=js&"
import style0 from "./ProfessionItem.vue?vue&type=style&index=0&id=4294660c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4294660c",
  null
  
)

export default component.exports